import { createFileRoute } from "@tanstack/react-router";
import { ContentPage } from "@/components/seo/content-page";
import { pickContent } from "@/assets/generated";
import { seoMeta } from "@/lib/seo/head";

export const Route = createFileRoute("/contatti")({
  head: () => seoMeta({
    title: "Contatti - LexAIPro",
    description: "Vendite, supporto, partnership e richieste DPA per LexAIPro.",
    path: "/contatti",
  }),
  component: () => (
    <ContentPage
      eyebrow="Contatti"
      title="Parla con il team LexAIPro"
      lead="Vendite, supporto tecnico, richieste DPA, partnership: rispondiamo entro un giorno lavorativo."
      breadcrumbs={[{name:"Home",path:"/"},{name:"Contatti",path:"/contatti"}]}
      sections={[
        { heading: "Email", bullets: ["Assistenza, vendite e privacy: beleadcreativestudio@proton.me"] },
        { heading: "Sede", body: "Italia. Tutti i dati restano in UE." },
      ]}
      cta={{ label: "Inizia la prova gratuita", to: "/signup" }}
      heroImage={pickContent(48)}
      updated="2026"
    />
  ),
});
